import { Select } from 'antd';
import { FC } from 'react';

const { Option } = Select;

type Props = {
  value?: string[];
  onChange?: (value: string[]) => void;
  placeholder?: string;
};

const TagsField: FC<Props> = (props: Props) => {
  const { value = [], onChange, placeholder, ...componentProps } = props;
  return (
    <Select
      placeholder={placeholder}
      mode="tags"
      style={{ width: '100%' }}
      onChange={onChange}
      value={value}
      {...componentProps}
    >
      {value.map((v) => (
        <Option key={v} value={v}>
          {v}
        </Option>
      ))}
    </Select>
  );
};

export default TagsField;
